var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStandbyTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6916 11824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-6916 -11824)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4802.99 -13552.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2087.489,1743.082c.395.875.831,1.666,1.117,2.508a9.09,9.09,0,0,1-2.569,9.639,8.968,8.968,0,0,1-7.066,2.252,8.95,8.95,0,0,1-7.814-6.8,8.915,8.915,0,0,1,2.244-8.559,8.632,8.632,0,0,1,4.784-2.608c.747-.144.748-.139.748-.891,0-.364-.014-.73,0-1.093.015-.28-.1-.357-.364-.355a10.357,10.357,0,0,1-1.245-.061.917.917,0,0,1-.816-.859.959.959,0,0,1,.627-1.054,1.8,1.8,0,0,1,.572-.1q2.246-.012,4.491,0a1.1,1.1,0,0,1,1.151.63.967.967,0,0,1-.747,1.38,9.918,9.918,0,0,1-1.283.064c-.239,0-.323.091-.32.322.009.521.012,1.042,0,1.562-.006.232.1.3.305.359a20.74,20.74,0,0,1,2.551.807,12.1,12.1,0,0,1,1.912,1.191c.216.147.334.162.517-.033.346-.371.707-.729,1.083-1.069a.98.98,0,0,1,1.158-.13.944.944,0,0,1,.463,1.1,1.989,1.989,0,0,1-.425.636C-2086.779,1742.339-2087.168,1742.738-2087.489,1743.082Zm-7.5-1.7a7.006,7.006,0,0,0-7.066,7.034,6.976,6.976,0,0,0,6.86,7.067,7,7,0,0,0,7.243-7A7.019,7.019,0,0,0-2094.993,1741.381Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.05,
    height: 6.6,
    rx: 1.025,
    transform: "translate(-2096.035 1743.355)",
    fill: "#71aff8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStandbyTime);
export default __webpack_public_path__ + "static/media/icon-standbyTime.8dd8aa8d.svg";
export { ForwardRef as ReactComponent };